//@flow
import React from 'react';
import css from './elements.css';
type Props = {
  children: *
}
class ButtonGroup extends React.Component < Props > {
  static defaultProps = {

  }
  render() {
    return <div className={css.buttonGroup}>{this.props.children}</div>
  }
}
export default ButtonGroup;